/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SAMLChallengeOptions
 */
export interface SAMLChallengeOptions {
    /**
     * 
     * @type {string}
     * @memberof SAMLChallengeOptions
     */
    start_authentication_url: string;
}

/**
 * Check if a given object implements the SAMLChallengeOptions interface.
 */
export function instanceOfSAMLChallengeOptions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "start_authentication_url" in value;

    return isInstance;
}

export function SAMLChallengeOptionsFromJSON(json: any): SAMLChallengeOptions {
    return SAMLChallengeOptionsFromJSONTyped(json, false);
}

export function SAMLChallengeOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAMLChallengeOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'start_authentication_url': json['start_authentication_url'],
    };
}

export function SAMLChallengeOptionsToJSON(value?: SAMLChallengeOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'start_authentication_url': value.start_authentication_url,
    };
}

